// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__nPloF","list":"PatternAutocomplete_list__wAS8t"};